import { createStore } from 'vuex'

const store = createStore({
  state() {
    return {
      msalConfig: {
        auth: {
          clientId: process.env.VUE_APP_CLIENT_ID,
          authority: process.env.VUE_APP_AUTHORITY,
          redirectUri: window.location.origin, // Must match Azure AD registration exactly
          postLogoutRedirectUri: window.location.origin,
          scopes: [`${process.env.VUE_APP_SCOPE_URL}test`],
        },
        cache: {
          cacheLocation: 'localStorage',
        },
      },
      accessToken: '',
    }
  },
  mutations: {
    setAccessToken(state, token) {
      state.accessToken = token
    },
  },
})

export default store
